















































import Vue from 'vue';
import JerseyButtonRed from '@/components/elements/JerseyButtonRed.vue';
import JerseyQuestion from '@/components/elements/JerseyQuestion.vue';
import JerseyButton from '@/components/elements/JerseyButton.vue';
import QuestionLayout from '@/views/QuestionLayout.vue';

import Girl from '@/components/svg/Girl.vue';
import Boy from '@/components/svg/Boy.vue';
import Surprise from '@/components/svg/Surprise.vue';

import { Gender } from '../../common/api/Gender';

export default Vue.extend({
  name: 'WhatAreYouHaving',
  data() {
    return {
      isMobile: false,
    };
  },
  components: {
    JerseyButtonRed,
    JerseyQuestion,
    JerseyButton,
    Girl,
    Boy,
    Surprise,
    QuestionLayout,
  },
  methods: {
    selectBoy() {
      this.$store.commit('set_gender', 'boy');
    },
    selectGirl() {
      this.$store.commit('set_gender', 'girl');
    },
    selectSurprise() {
      this.$store.commit('set_gender', 'surprise');
    },
    isSlected(gender: string) {
      return (this as any).$store.state.gender.selected === gender;
    },
    onResize() {
      this.isMobile = window.innerWidth < 850 || window.innerHeight < 500;
    },
  },
  computed: {
    question() {
      return (this as any).$store.state.gender.question;
    },
    selected() {
      return (this as any).$store.state.gender.selected;
    },
    isDisabled() {
      return (this as any).$store.state.gender.selected === '';
    },
  },
  mounted() {
    window.addEventListener('resize', this.onResize);
    this.onResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.onResize);
  },
});
